import Tables from "layouts/tables";
import Notifications from "layouts/notifications";
import SignIn from "layouts/authentication/sign-in";
import Icon from "@mui/material/Icon";
import SolicitudesPropias from "layouts/tables/SolicitudesPropias";
import HistorialCaso from "layouts/tables/consultaTickets/HisotrialCasos";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import React from "react";
import Logout from "layouts/tables/CerrarSesion";
import CerrarSesion from "layouts/tables/CerrarSesion";
import ComentariosGlpi from "layouts/tables/consultaTickets/ComentariosGlpi";

// Definir las rutas base
const routesBase = [
  {
    type: "collapse",
    name: "Mis Solicitudes",
    key: "propias",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/SolicitudesPropias/:correo",
    component: <SolicitudesPropias />,
  },
  {
    type: "collapse",
    name: "Historial de Casos",
    key: "historial",
    icon: <Icon fontSize="small">history</Icon>,
    route: "/Historial",
    component: <HistorialCaso />,
  },
  {
    type: "collapse",
    name: "Repositorio GLPI",
    key: "casos-glpi",
    icon: <Icon fontSize="small">comment</Icon>,
    route: "/comentarios",
    component: <ComentariosGlpi />,
  },
  {
    type: "collapse",
    name: "Salir",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
];

export default routesBase;
